import React, { useState, useContext } from "react";
import axios from "../../../../axios/index";

// Context
import { UserContext } from "../../../Context/UserContextProvider";

import { Form } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import { useHistory } from "react-router-dom";
import ImageUploading from "react-images-uploading";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Styles
import styles from "./../UserManagment.module.css";
import ModalStyles from "./../../DashboardReuseAbleComponents/Modal.module.css";
import Dstyles from "./../../DashboardFileManagement/DashboardFileManagement.module.css";
import uploadImgStyles from "../../DashboardReuseAbleComponents/AddNewFiles/UploadFileImages.module.css";

//Images
import trashIcon from "../../../../assets/img/DashboardICons/TrashIcon.svg";
import addIcon from "../../../../assets/img/DashboardICons/CircleAddIconBlue.svg";
import portraitIcon from "../../../../assets/img/DashboardICons/PortraitIcon.svg";
import { FormControlLabel } from "@mui/material";
import { IOSSwitch } from "../../DashboardArchivedFiles/ArchiveDetail/IOSSwitch";

const ModalEditForm = props => {
  const { userToken } = useContext(UserContext);
  const history = useHistory();
  const [btnLoader, setBtnLoader] = useState(false);
  const [image, setImage] = useState([]);
  const maxNumber = 1;

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover={false}
        theme="light"
      />

      <style type="text/css">
        {`
                .modal {
                    background: #3335;
                }

                .modal-content {
                    width: 870px;
                    border-radius: 24px;
                }

                .modal-header {
                    align-items: center !important;
                }
            `}
      </style>

      <Modal show={props.show} onHide={props.onHide} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
        <Modal.Header closeButton dir="rtl">
          <div className="w-100 d-flex align-items-start justify-content-between px-3">
            <div className={ModalStyles.title}>ویرایش اطلاعات کاربر</div>
          </div>
        </Modal.Header>
        <Modal.Body dir="rtl">
          <div dir="rtl" className="text-right w-100 d-flex align-items-start justify-content-between flex-wrap mt-3 mb-2 pt-4 px-3">
            <Form.Group className={`${styles.total_form_group} mb-4 pb-1 d-flex flex-column`}>
              <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="fullName">
                {" "}
                نام و نام‌خانوادگی{" "}
              </Form.Label>
              <Form.Control
                className={`${styles.form_control_input} shadow-none`}
                type="text"
                id="name"
                name="name"
                value={props.formUserManagmentInfo.name}
                onChange={props.formUserManagmentChangeHandler}
              />
              <Form.Control
                className={`${styles.form_control_input} shadow-none mt-4`}
                type="text"
                id="family"
                name="family"
                value={props.formUserManagmentInfo.family}
                onChange={props.formUserManagmentChangeHandler}
              />
            </Form.Group>
            {/* <Form.Group className={`${styles.total_form_group} mb-4 pb-1 d-flex flex-column`}>
                            <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="birthDate"> تاریخ تولد </Form.Label>
                            <DatePicker
                                id="birthDate"
                                value={props.formBirthDate}
                                onChange={props.formBirthDateChangeHandler}
                                calendar={persian}
                                locale={persian_fa}
                                format="YYYY-MM-DD"
                            />
                        </Form.Group> */}
            <Form.Group className={`${styles.total_form_group} mb-4 pb-1 d-flex flex-column`}>
              <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="callNumber">
                {" "}
                شماره تماس{" "}
              </Form.Label>
              <Form.Control
                className={`${styles.form_control_input} shadow-none`}
                type="tel"
                id="callNumber"
                name="callNumber"
                value={props.formUserManagmentInfo.callNumber}
                onChange={props.formUserManagmentChangeHandler}
              />
            </Form.Group>
            {/* <Form.Group className={`${styles.total_form_group} mb-4 pb-1 d-flex flex-column`}>
                            <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="numberId"> ایمیل </Form.Label>
                            <Form.Control className={`${styles.form_control_input} shadow-none`} type="email" id="email" name="email" value={props.formUserManagmentInfo.email} onChange={props.formUserManagmentChangeHandler} />
                        </Form.Group> */}
            {/* <Form.Group className={`${styles.total_form_group} mb-4 pb-1 d-flex flex-column`}>
                            <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="registryDate"> تاریخ عضویت </Form.Label>
                            <DatePicker
                                id="registryDate"
                                value={props.formRegistryDate}
                                onChange={props.formRegistryDateChangeHandler}
                                calendar={persian}
                                locale={persian_fa}
                                format="YYYY-MM-DD"
                            />
                        </Form.Group> */}
          </div>
          <div className="d-flex flex-column justify-content-center align-items-start flex-wrap mt-4 px-4">
            <div className="d-flex align-items-center justify-content-center mb-4">
              <div className={`ms-2 ${uploadImgStyles.circle_green}`}></div>
              <div className={uploadImgStyles.title_sm_gray}>
                انتخاب عکس پروفایل (<span className="text-danger">درصورتی که عکس جدید انتخاب نکنید همان عکس قبلی به عنوان پروفایل در نظر گرفته خواهد شد</span>)
              </div>
            </div>
            <ImageUploading multiple value={image} onChange={onChange} maxNumber={maxNumber} dataURLKey="data_url">
              {({ imageList, onImageUpload, onImageRemove, dragProps }) => (
                // write your building UI
                <div className="w-100 d-flex align-items-center flex-wrap">
                  {imageList.map((image, index) => (
                    <div
                      key={index}
                      className={`d-flex flex-column align-items-center justify-content-center my-3 ms-4 ${uploadImgStyles.uploaded_img_container}`}>
                      <img className={uploadImgStyles.uploaded_img} src={image.data_url} alt="uploaded-img" />
                      <div className={uploadImgStyles.remove_img_container}>
                        <img onClick={() => onImageRemove(index)} src={trashIcon} alt="icon" />
                      </div>
                    </div>
                  ))}

                  <div className={`d-flex align-items-center justify-content-center mb-4 ${uploadImgStyles.upload_img_container}`}>
                    <div className="d-flex flex-column align-items-center justify-content-center position-relative">
                      <img src={portraitIcon} alt="icon" />
                      <img className={uploadImgStyles.add_icon} src={addIcon} alt="icon" onClick={onImageUpload} {...dragProps} />
                    </div>
                  </div>
                </div>
              )}
            </ImageUploading>
          </div>
          <div
            style={{
              display: "flex",
              // justifyContent: "space-between",
              gap: "70px",
              alignItems: "center",
            }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "10px",
              }}>
              <FormControlLabel
                sx={{ m: 0 }}
                onChange={event => {
                  props.setFormUserManagmentInfo({ ...props.formUserManagmentInfo, isActive: event.target.checked });
                }}
                control={<IOSSwitch sx={{ m: 1 }} />}
                checked={props.formUserManagmentInfo.isActive}
              />
              <span
                style={{
                  height: "fit-content",
                }}>
                وضعیت دسترسی
              </span>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "10px",
              }}>
              <FormControlLabel
                sx={{ m: 0 }}
                onChange={event => {
                  props.setFormUserManagmentInfo({ ...props.formUserManagmentInfo, isShowEstates: event.target.checked });
                }}
                control={<IOSSwitch sx={{ m: 1 }} />}
                checked={props.formUserManagmentInfo.isShowEstates}
              />
              <span
                style={{
                  height: "fit-content",
                }}>
                وضعیت نمایش آگهی‌ها
              </span>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="w-100 d-flex justify-content-center align-items-center mb-3">
            {btnLoader ? (
              <div className={Dstyles.btn_loader_container}>
                <div className={Dstyles.btn_spinner}></div>
              </div>
            ) : (
              <div className={`d-flex align-items-center justify-content-center ms-3 ${ModalStyles.filled_btn}`} onClick={postHandler}>
                ثبت
              </div>
            )}
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );

  function notify(text, type) {
    if (type === "success") {
      toast.success(text, {
        position: "top-right",
        autoClose: 8000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else {
      toast.error(text, {
        position: "top-right",
        autoClose: 8000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      setBtnLoader(false);
    }
  }

  function onChange(imageList) {
    setImage(imageList);
  }

  async function postHandler() {
    try {
      notify("درحال تغییر اطلاعات کاربر", "success");
      setBtnLoader(true);
      var data = new FormData();
      data.append("Id", props.id);
      data.append("Avatar", image == "" ? props.avatarName : image[0].file);
      data.append("Name", props.formUserManagmentInfo.name);
      data.append("Family", props.formUserManagmentInfo.family);
      data.append("PhoneNumber", props.formUserManagmentInfo.callNumber);
      // data.append('Email', "mahdizirak@gmail.com");
      // data.append("Email", props.formUserManagmentInfo.email || null);
      // data.append('ParentId', 0);
      data.append("isActive", props.formUserManagmentInfo.isActive);
      data.append("isShowEstates", props.formUserManagmentInfo.isShowEstates);

      const apiData = await axios.put("Users", data, {
        headers: { authorization: "Bearer " + userToken },
      });
      // console.log(apiData)
      if (apiData.data.isSuccess === false) {
        notify(apiData.data.metaData.message, "error");
      } else {
        notify("اطلاعات کاربر با موفقیت تغییر یافت", "success");
        history.push("/user-managment-info");
        setBtnLoader(false);
        props.onHide();
      }
      // window.location.reload(false)
    } catch (error) {
      notify("خطای سرور", "error");
      // console.log(error)
      setBtnLoader(false);
    }
  }
};

export default ModalEditForm;
